import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';

const Hero = () => {
  const navigate = useNavigate();

  const scrollToAbout = () => {
    const aboutSection = document.getElementById('about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="video-background">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline
          className="hero-video"
        >
          <source src="/hero-video.mov" type="video/mp4" />
        </video>
        <div className="video-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="hero-text animate-fade-in-up">
          <h1 className="hero-title">Kothu Rotti</h1>
          <p className="hero-tagline">SRILANKAN & INDIAN SPICY AROMA RESTAURANT</p>
          <div className="hero-buttons">
            <button onClick={() => navigate('/order')} className="btn-primary">Order Now</button>
            <a href="tel:07402807007" className="btn-glass">Reserve a Table</a>
            <button onClick={scrollToAbout} className="btn-glass">Discover More</button>
          </div>
        </div>

        <button onClick={scrollToAbout} className="scroll-indicator">
          <ChevronDown size={32} />
        </button>
      </div>
    </section>
  );
};

export default Hero;